<template>
	<div>
    <p class="font-medium">
      {{ getUserAuthInfo.name.split(' ')[0] }}'s {{ address.alias }}
    </p>
    <p class="font-semibold leading-8 text-xl my-5">
      {{ address.full_name }}
    </p>
    <p>
      <span v-if="address.flat_no">{{ address.flat_no }}</span>
      <span v-if="address.flat_no && address.floor_no">, </span>
      <span v-if="address.floor_no">{{ address.floor_no }}</span>
      <span v-if="address.building_name && address.floor_no">, </span>
      <span v-if="address.building_name">{{ address.building_name }}</span>
    </p>
    <p>
      <span v-if="address.address_line1">{{ address.address_line1 }}</span>
      <span v-if="address.address_line1 && address.address_line2">, </span>
      <span v-if="address.address_line2">
        {{ address.address_line2 }}
      </span>
    </p>
    <p>{{ address.city }}, {{ address.postcode }}</p>
    <p>{{ address.region }}, {{ address.country }}</p>
    <p>Tel: {{ address.phone_number }}</p>
    <p>{{ address.alias }}</p>
    <div v-if="allowActions" class="pt-5 flex justify-between">
      <a
        class="flex items-center text-sm text-dark"
        @click.stop="$emit('delete', address)"
      >
        <i class="icon-remove mr-2" />
        <span class="opacity-50 pt-1">Remove</span>
      </a>
      <a
        class="px-6 py-1 rounded-full font-medium"
        :class="isSelected ? 'bg-white' : 'bg-dark-b '"
        @click.stop="$emit('edit', address)"
      >
        Edit
      </a>
    </div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
	name: 'AddressBox',
	props: {
		address: {
			type: Object,
			required: true
		},
    isSelected: {
      type: Boolean,
      required: false
    },
		allowActions: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapGetters ([ 'getUserAuthInfo' ])
	}
}
</script>
